import {
    Alert,
    Button, CircularProgress,
    Container,
    Divider, FormControl,
    FormControlLabel,
    FormLabel,
    Grid, InputLabel,
    Link, List, ListItem, ListItemButton, ListItemIcon, ListItemText, MenuItem, Radio, Select,
    Stack,
    TextField,
    Typography
} from "@mui/material";
import React, {ChangeEvent, useEffect, useState} from "react";
import {useNavigate} from "react-router";
import {useUserDataContext, useUserLoginContext} from "../Contexts/UserContext";
import {
    CustomerSearchQueryVariables, CustomerType,
    LoginResultType,
    useCustomerSearchQuery,
    useLoginMutation
} from "../generated/graphql";
import {useBasketContext} from "../Contexts/BasketContext";
import {theatres} from "../theatres";
import {Refresh, Search} from "@mui/icons-material";
import {useSiteDataContext} from "../Contexts/SiteDataContext";


function CustomerSearchPage() {
    const navigate = useNavigate();
    const setUser = useUserLoginContext();
    const basket = useBasketContext();
    const user = useUserDataContext();
    const [state,setState] = useState<CustomerSearchQueryVariables>({customerNumber:'',email:'',postcode:''});
    const [searchResults,performSearch] = useCustomerSearchQuery({variables:state,pause:true});
    const [error,setError] = useState('');
    const siteData = useSiteDataContext();
    const page = siteData.pages.internalSearch;
    useEffect(()=>{
        if(!user?.token) return;
        if(!user?.internal) {
            navigate('/');
            return;
        }
        setState((v)=>{
            const p = {...v};
            p.userToken = user?.token;
            return p;
        })
    },[user?.token,user?.internal]);
    function onChange(evt) {
        setState((oldState)=>{
            var target = evt.target as HTMLInputElement;
            var v = {...oldState};
            v[target.name as keyof CustomerSearchQueryVariables] = target.value;
            return v;
        });
    }
    async function doSearch(evt) {
        evt.preventDefault();
        setError('');
        console.log('state is',state);
        if(state.email=='' && state.postcode=='' && state.customerNumber=='') {
            setError('Please enter a search term');
        }
        const variables = {...state};
        variables.userToken = user?.token;

        performSearch({variables:variables,requestPolicy:'network-only'});
    }
    function doSelect(customer) {
        basket.setCustomer(customer);
        navigate('/select-membership');
    }
    return (<Container maxWidth="md">
        <Grid container spacing={8}>
            <Grid item xs={12} md={6}>
                <Typography typography="h1" color="primary">{page.title}</Typography>
                <Typography typography="subtitle" color="primary">{page.subtitle}</Typography>
                <Divider sx={
                    (theme)=>({
                        paddingTop:theme.spacing(4)
                    })}
                />
            </Grid>
            <Grid item xs={12} md={6}>
                <form onSubmit={doSearch}>
                {!!error &&
                  <Alert severity="error" sx={(theme)=>({borderRadius: 0, marginBottom:theme.spacing(2)})}>{error}</Alert>
                }
                <TextField value={state.customerNumber} name="customerNumber" label="Customer number" fullWidth={true} variant="standard" onChange={onChange}/>
                <TextField value={state.postcode} name="postcode" label="Postcode" fullWidth={true} variant="standard" onChange={onChange}/>
                <TextField type="text" name="email" value={state.email} label="Email" fullWidth={true} variant="standard" onChange={onChange}
                />
                <Button type="submit" color="secondary" disabled={searchResults.fetching||(!state.email && !state.customerNumber && !state.postcode)} startIcon={searchResults.fetching?<CircularProgress size="1rem"/>:<Search fontSize="1rem"/>} sx={(theme)=>({marginTop:theme.spacing(3),marginBottom:theme.spacing(2)})} fullWidth={true} variant="contained" size="large">Search</Button>
                </form>
                {searchResults.data && !searchResults.fetching && searchResults?.data?.customerSearch?.results?.length==0 &&
                  <Alert severity="warning">{page.noMatches}</Alert>
                }
                {searchResults.data && !searchResults.fetching && <List>
                    {searchResults?.data?.customerSearch?.results?.map((option) => (
                        <ListItem key={option!.id}>
                            <ListItemButton dense onClick={()=>{
                                if(!option.email) return;
                                doSelect(option!)
                            }} color="warning">
                                <ListItemText id={'label-' + option.id!} secondary={
                                    <div>Customer Number: {option.customerNumber!}<br/>{option.firstName??''} {option.lastName??''}<br/>{option.postcode??''}
                                {(option.email=='' || !option.email) &&
                                    <Alert severity="warning">{page.missingEmail}<br/>
                                    <Button onClick={doSearch} startIcon={<Refresh/>}>Refresh List</Button></Alert>
                                }</div>
                                }>
                                    <Typography gutterBottom={true} typography="body1"
                                                color="primary">{option.email}</Typography>

                                </ListItemText>
                            </ListItemButton>
                        </ListItem>
                    ))}
                </List>
                }

            </Grid>
        </Grid>
    </Container>);
}
export default CustomerSearchPage;